export default __webpack_public_path__ + "static/media/tropical-house-2.99aeca91.jpg";